import { TextField } from '@mui/material'
import React from 'react'
import { useRecoilValue } from 'recoil';
import useSavePatient from 'src/Patient/hooks/useSavePatient';
import { errorsFormRegisterState, valuesFormRegisterState } from 'src/Patient/state/atoms';
import InputLabelCustom from 'src/shared/components/forms/InputLabelCustom'

const PhoneMobileField = () => {
    const { handleChange } = useSavePatient();
    const { uswFonoMovil } = useRecoilValue(valuesFormRegisterState);
    const { uswFonoMovil: errorUswFonoMovil } = useRecoilValue(errorsFormRegisterState);

    return (
        <>
            <InputLabelCustom htmlFor="input-movil" text="Teléfono móvil" />
            <TextField
                id="input-movil"
                size="small"
                placeholder="Ej: 957851112"
                error={errorUswFonoMovil && errorUswFonoMovil.length > 0 ? true : false}
                helperText={errorUswFonoMovil && errorUswFonoMovil.length > 0 ? `${errorUswFonoMovil.join("\n")}` : ''}
                style={{ width: '100%' }}
                name="uswFonoMovil"
                type="text"
                value={uswFonoMovil || ""}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{
                    maxLength: 9
                }}
                variant="outlined"
                onChange={handleChange}
                autoComplete="off"
            />
        </>
    )
}

export default PhoneMobileField
